import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";
import { prepareBaseGetListParams } from "../utils/fetch/PrepareBaseGetListParams";


export const UserRoleService = {

    list: (criteria) => {
        const params = prepareBaseGetListParams(criteria);
        const url = `/portal/users/roles/list?${params.toString()}`;
        return fetchWithAuth(url, { method: 'GET' });
    },

    getList(operatorId, merchantId) {
        
        const params = new URLSearchParams();
        if (operatorId) {
            params.append('operatorId', operatorId);
        }
        if (merchantId) {
            params.append('merchantId', merchantId);
        }
        
        const url = `/portal/users/roles${params.toString() ? '?' + params.toString() : ''}`;
        return fetchWithAuth(url, { method: 'GET' });
    },
    getStatusList: () => {
        return fetchWithAuth('/portal/users/roles/status-list', { method: 'GET' });
    },
    getAssignedUsersCount: (profileId) => {
        return fetchWithAuth(`/portal/users/roles/${profileId}/assigned-users-count`, { method: 'GET' });
    },
    deactivate: (profileId) => {
        return fetchWithAuth(`/portal/users/roles/${profileId}/deactivate`, { method: 'PUT' });
    },
    delete: (profileId) => {
        return fetchWithAuth(`/portal/users/roles/${profileId}`, { method: 'DELETE' });
    },
    getTemplate: () => {
        return fetchWithAuth('/portal/users/roles/template', { method: 'GET' });
    },
    getNameStatus: (name, userRoleId) => {
        return fetchWithAuth(`/portal/users/roles/name-status`, { method: 'PUT', body: JSON.stringify({ name, userRoleId }) });
    },
    get: (userRoleId) => {
        return fetchWithAuth(`/portal/users/roles/${userRoleId}`, { method: 'GET' });
    },
    create: (role) => {
        return fetchWithAuth('/portal/users/roles', { method: 'POST', body: JSON.stringify(role) });
    },
    update: (role) => {
        return fetchWithAuth(`/portal/users/roles/${role.id}`, { method: 'PUT', body: JSON.stringify(role) });
    }
}